import Model from '../utils/Model'
class RoleScope {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'RoleScope'

export const DEPARTMENT = new RoleScope('DPT', 'department', '部门同组')
export const INDIVIDUAL = new RoleScope('IND', 'individual', '个人')

export const ROLE_SCOPES = [DEPARTMENT, INDIVIDUAL]
/**
 *  return null:没找到.
 */
export function getRoleScopeByCode(code) {
  return Model.getObjByCode(code, ROLE_SCOPES)
}
